export const formatPhoneNumber = (phoneNumber: string, onlyEnd?: boolean) => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  const countryCode = cleaned.slice(0, 2);
  const areaCode = cleaned.slice(3, 5);
  const firstPart = cleaned.slice(5, 9);
  const secondPart = cleaned.slice(9, 13);
  if (onlyEnd) return secondPart;
  return `(+${countryCode}) ${areaCode}-${firstPart}-${secondPart}`;
};
